import { Component } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

function maxWords(max: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = (control.value || '').toString();
    const words = raw.trim() ? raw.trim().split(/\s+/).length : 0;
    return words > max ? { maxWords: { max, actual: words } } : null;
  };
}

@Component({
  selector: 'app-force-approve-popup',
  templateUrl: './force-approve-popup.component.html',
  styleUrls: ['./force-approve-popup.component.scss'],
})
export class ForceApprovePopupComponent {
  readonly maxChars = 500;
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ForceApprovePopupComponent>,
  ) {
    this.form = this.fb.group({
      analyst_report: [
        '',
        [Validators.required, maxWords(100), Validators.maxLength(this.maxChars)],
      ],
    });
  }

  get wordCount(): number {
    const raw = (this.form.get('analyst_report')?.value || '').toString();
    return raw.trim() ? raw.trim().split(/\s+/).length : 0;
  }

  get charCount(): number {
    const raw = (this.form.get('analyst_report')?.value || '').toString();
    return raw.length;
  }

  get isCharLimitExceeded(): boolean {
    return this.charCount > this.maxChars;
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  proceed(): void {
    if (this.form.invalid) return;
    this.dialogRef.close(this.form.value.analyst_report);
  }
}
